import { createRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { rootRoute } from './__root';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { PermissionGate } from '@/components/admin/permission-gate';
import { AdminSubNav } from '@/components/admin/admin-sub-nav';
import { QueueGauge } from '@/components/admin/queue-gauge';

export const adminObservabilityQueuesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/observability/queues',
  component: AdminObservabilityQueuesPage,
});

function AdminObservabilityQueuesPage() {
  return (
    <PermissionGate permission="platform:observe">
      <Queues />
    </PermissionGate>
  );
}

function Queues() {
  const queuesQuery = useQuery({
    queryKey: queryKeys.admin.queues(),
    refetchInterval: 5_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/admin/observability/queues');
      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Queues</h1>
      <AdminSubNav active="queues" />
      {queuesQuery.isLoading && (
        <p className="text-sm text-muted-foreground">Loading queue stats…</p>
      )}
      {queuesQuery.isError && (
        <p className="text-sm text-red-600">Failed to load queue stats.</p>
      )}
      {queuesQuery.data && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {queuesQuery.data.queues.map((q) => (
            <QueueGauge key={q.queueName} queue={q} />
          ))}
        </div>
      )}
    </div>
  );
}
